import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  padding: {
    xs: '2.4rem 1.6rem 3.2rem',
    md: '2.6rem 5.6rem 4rem',
    lg: '3rem 4.8rem 4.7rem',
  },
  background: 'linear-gradient(180deg, #184A9B 0%, #03378B 110%)',
}

export const heroLeftSideWrapperSx: SxProps<Theme> = {
  maxWidth: {
    lg: '144rem',
    xl: '151.6rem',
  },
  margin: 'auto',
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: {
    xs: 'column',
    lg: 'row',
  },
}

export const mobileOrTabletCertificationCardsContainerSx: SxProps<Theme> = {
  marginTop: {
    xs: '2.8rem',
  },
}

export const heroLeftSideContentSx: SxProps<Theme> = {
  padding: {
    xs: '0 0.8rem',
    md: 0,
  },
  alignItems: {
    xs: 'stretch',
    lg: 'flex-start',
  },
  marginTop: {
    xs: '3rem',
    lg: '1rem',
    xl: '1.8rem',
  },
  order: {
    xs: 2,
    lg: 1,
  },
  textAlign: {
    xs: 'center',
    lg: 'initial',
  },
}

export const heroTitleSx: SxProps<Theme> = {
  marginTop: {
    xs: '1.2rem',
    md: '1.4rem',
  },
  fontWeight: {
    xs: 500,
    md: 700,
  },

  color: (theme) => theme.palette.primary.contrastText,
}

export const heroSubtitleSx: SxProps<Theme> = {
  marginLeft: 'auto',
  marginRight: 'auto',
  whiteSpace: {
    xs: 'initial',
    lg: 'pre-line',
  },
  fontWeight: 500,
  marginTop: {
    xs: '1.2rem',
    md: '0.8rem',
    lg: '2.4rem',
  },
  '& > span:not(:first-of-type)': {
    display: 'block',
    marginTop: {
      xs: '0.8rem',
      md: '1rem',
      lg: '0.6rem',
      xl: '0.8rem',
    },
  },
  color: (theme) => theme.palette.primary.contrastText,
}

export const getStartedForFreeButtonSx: SxProps<Theme> = {
  fontWeight: '700',
  alignSelf: {
    md: 'center',
    lg: 'initial',
  },
  minHeight: {
    lg: '5.2rem',
  },
  paddingLeft: {
    md: '2.2rem',
  },
  paddingRight: {
    md: '1.8rem',
  },
  marginTop: {
    xs: '1.6rem',
    lg: '2rem',
  },
}

export const heroRightSideWrapperSx: SxProps<Theme> = {
  alignItems: 'center',
  gap: '2rem',
  position: 'relative',
  order: {
    xs: 1,
    lg: 2,
  },
}

export const heroImageBrightnessSx: SxProps<Theme> = {
  opacity: 0.6,
  filter: 'blur(55px)',
  position: 'absolute',
  width: '70%',
  height: '60%',
  top: '8%',
  background: (theme) => theme.palette.background.paper,
}

export const heroImageSx: SxProps<Theme> = {
  minWidth: { xs: '100%', lg: '79.8rem' },
  width: '100%',
  maxWidth: { md: '65rem', lg: '79.8rem' },
  height: { lg: '46.7rem' },
  zIndex: 1,
}

export const heroOverTitleSx: SxProps<Theme> = {
  alignSelf: {
    xs: 'center',
    lg: 'start',
  },
  paddingBottom: '0.8rem',
  color: (theme) => theme.palette.primary.contrastText,
  borderBottom: (theme) => `0.1rem solid ${theme.palette.primary.contrastText}`,
}
